import { EXTRA_SYMBOLS, SUBSCRIPTS } from "@/lib/chem";

export const SubscriptBar = ({ onInsert, onFormula }) => (
  <div className="flex flex-wrap items-center gap-1.5 p-2 rounded-lg bg-[rgba(15,23,42,0.85)] border border-[rgba(71,85,105,0.45)]" data-testid="subscript-bar">
    <span className="eyebrow mr-1">Alt simge</span>
    {[...SUBSCRIPTS, ...EXTRA_SYMBOLS].map((c) => (
      <button key={c} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onInsert(c)}
        className="h-8 min-w-8 px-2 rounded-md bg-[rgba(255,255,255,0.08)] hover:bg-[#FACC15] hover:text-[#05070D] font-bold transition-colors duration-100"
        data-testid={`subscript-${c}`}>
        {c}
      </button>
    ))}
    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={onFormula}
      className="h-8 px-3 rounded-md border border-[#34D399]/50 text-[#6EE7B7] hover:bg-[#34D399]/15 text-sm font-semibold"
      data-testid="subscript-formula-button" title="Seçili metindeki rakamları alt simgeye çevirir">
      Seçimi formüle çevir (H2O → H₂O)
    </button>
  </div>
);
